"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var SuccessMessage = function SuccessMessage(_ref) {
  var reference = _ref.reference;
  return _react["default"].createElement("div", null, _react["default"].createElement("h3", null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.flywire.payment.success.title"
  })), _react["default"].createElement("p", null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.flywire.payment.success.reference",
    values: {
      reference: reference
    }
  })));
};
var _default = exports["default"] = SuccessMessage;